import type {Indexer} from 'types';

export const HTTP_STATUS_ABORTED = 299;

export type Violation = {
  field: string;
  message: string;
};

export type ProblemConstraintViolation = {
  type: string;
  title: string;
  detail?: string;
  status: number;
  violations: Violation[];
};

export type ErrorKeyAndMessage = {
  errorKey?: string;
  errorMessage?: string;
} & Indexer;

export type ErrorInfo = ProblemConstraintViolation | ErrorKeyAndMessage;

export type HttpErrorType = {
  status: number;
  url: string;
  message: string;
  errorKey?: string;
  info?: ErrorInfo;
  innerError?: Error;
};

export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly url: string,
    public readonly message: string,
    public readonly errorKey?: string,
    public readonly info?: ErrorInfo,
    public readonly innerError?: Error,
  ) {
    super(message);
  }
}
